import React, { createContext, useEffect, useMemo, useState } from 'react';
import { ErrorMessages, debounce, triggerNotification, useGetApiRequests, useSelector } from '../../../common/CommonExport';
import DepartmentRender from './DepartmentRender';
import { AppContextData, DepartmentTableRecord } from '../OrganisationsInterfaces';
import { PaginationProps } from 'antd';
import PopupModal from '../../employee/employee-details/employee-profile/modal/PopupModal';
import { DepartmentRootState, DepartmentApiItem } from './types/DepartmentTypes';
import { AxiosResponse } from 'axios';

export const DepartmentContext = createContext<AppContextData>({} as AppContextData);

const Organization: React.FC = () => {
    const [departments, setDepartments] = useState<DepartmentTableRecord[]>([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const orgId = useSelector((state: DepartmentRootState) => state?.organisationId?.id);
    const [count, setCount] = useState<number>();
    const [loader, setLoader] = useState(false);
    const [modalerrMessage, setModalErrMessage] = useState('')
    const [popModal, setPopModal] = useState(false)
    const [modalResponse, setModalResponse] = useState('')
    const [modalButtonShow, setmodalButtonShow] = useState(true)

    const departmentApi = useGetApiRequests('department', 'GET');

    const onSearch = debounce((searchTerm: string) => {
        departmentGetApi(searchTerm);
    }, 500);
    const handleClosePopUpModal = () => {
        setPopModal(false)
    }
    const onShowSizeChange: PaginationProps['onShowSizeChange'] = (current, size) => {
        setCurrentPage(1);
        setPageSize(size);
    };
    const departmentGetApi = (searchTerm = '') => {
        if (searchTerm === '') {
            setLoader(true);
        } else {
            setTimeout(() => {
                setLoader(false)
            }, 1000)
        }
        const start: number = (currentPage - 1 === 0) ? 0 : currentPage - 1;
        const params: { start: number; limit: number; organisationId: string; isActive: boolean; search?: string } = {
            start: start,
            limit: pageSize,
            organisationId: orgId,
            isActive: true,
        };
        if (searchTerm !== '') {
            params.search = searchTerm
        }
        departmentApi('', params)
            .then((response) => {
                const res = response as AxiosResponse;
                const reformedDepartments = res.data.data.map((item: DepartmentApiItem, index: number) => ({
                    description: item.description,
                    email: item.leadEmail,
                    hod: item.headOfDepartment ? item.headOfDepartment.firstName + ' ' + item.headOfDepartment.lastName : '-',
                    hodId: item.headOfDepartment?.employeeId || '',
                    department: item.name,
                    key: item.departmentId,
                    isRosterPlanEligible: item?.isRosterPlanEligible
                }));
                setDepartments(reformedDepartments);
                setCount(res.data.totalResults)
                setLoader(false);
            })
            .catch((err: unknown) => {
                // triggerNotification('error', '', ErrorMessages.somethingWentWrong, 'topRight');
                // setTimeout(() => {
                //     setLoader(false)
                // }, 1000)
                setPopModal(true)
                setmodalButtonShow(false)
                setModalErrMessage(ErrorMessages.somethingWentWrong)
                setModalResponse('error')
                setTimeout(() => {
                    handleClosePopUpModal()
                    setLoader(false);
                }, 1500)

            });
    };
    useEffect(() => {
        const departmentTag = document.getElementsByClassName("ant-table-content") as HTMLCollectionOf<HTMLElement>;
        if (departmentTag.length > 0) {
            departmentTag[0].scrollTop = 0;
        }
        departmentGetApi();
    }, [currentPage, pageSize])

    const contextValue = useMemo(() => {
        return {
            departments,
            departmentGetApi,
            onSearch,
            onShowSizeChange,
            currentPage,
            pageSize,
            count,
            setCurrentPage,
            loader
        };
    }, [departments]);


    return (
        <div>
            <DepartmentContext.Provider value={contextValue}>
                <DepartmentRender />
            </DepartmentContext.Provider>
            {popModal && <PopupModal message={modalerrMessage} open={popModal} handleModalClose={handleClosePopUpModal} response={modalResponse} modalButtonShow={modalButtonShow} />}
        </div>
    );
};
export default Organization;
